import { useCallback, useState } from 'react';
import {
  CartUpdateAction,
  CartUpdatePropertyName,
  useCart,
  useUpdateCartMutation
} from '../../../hooks/useCart';
import { useCheckoutGiftSectionMessageContext } from '../CheckoutGiftSectionMessageProvider';

export enum CheckoutGiftSectionConfiguratorMode {
  Default,
  Frozen
}

export const useCheckoutGiftSectionConfigurator = () => {
  const [updateCart, { loading, error }] = useUpdateCartMutation();

  const { cart } = useCart();

  const enabled = cart.attributes.isGiftOrder;

  const { message, setMessage } = useCheckoutGiftSectionMessageContext();

  const handleClear = useCallback(() => setMessage(''), [setMessage]);

  const [mode, setMode] = useState<CheckoutGiftSectionConfiguratorMode>(() => {
    if (message.length === 0) return CheckoutGiftSectionConfiguratorMode.Default;

    return CheckoutGiftSectionConfiguratorMode.Frozen;
  });

  const handleEnable = useCallback(() => {
    updateCart(CartUpdateAction.Gifting, {
      id: cart.id,
      [CartUpdatePropertyName.Gifting]: true
    }).then(() => setMode(CheckoutGiftSectionConfiguratorMode.Frozen));
  }, [cart.id, updateCart]);

  const handleDisable = useCallback(
    () =>
      updateCart(CartUpdateAction.Gifting, {
        id: cart.id,
        [CartUpdatePropertyName.Gifting]: false,
        [CartUpdatePropertyName.GiftingMessage]: null
      }).then(() => setMode(CheckoutGiftSectionConfiguratorMode.Frozen)),
    [cart.id, updateCart]
  );

  const handleModeChange = useCallback(
    () => setMode(CheckoutGiftSectionConfiguratorMode.Default),
    []
  );

  const handleSave = useCallback(() => {
    updateCart(CartUpdateAction.Gifting, {
      id: cart.id,
      [CartUpdatePropertyName.Gifting]: true,
      [CartUpdatePropertyName.GiftingMessage]: message
    }).then(() => setMode(CheckoutGiftSectionConfiguratorMode.Frozen));
  }, [cart.id, message, updateCart]);

  return {
    enabled,
    updateCart,
    loading,
    mode,
    handleClear,
    handleEnable,
    handleDisable,
    handleModeChange,
    handleSave,
    message,
    setMessage,
    error
  };
};
